window.initMap = () => {
	let map;
	const area = document.getElementById("map"); // マップを表示させるHTMLの箱
	// マップの中心位置(例:原宿駅)
	const center = {
		lat: 35.3786461,
		lng: 138.5471637
	};



	const styles = [
		//地図全体の色味をカスタマイズ
		//グレースケールにするために、saturation(彩度)を最低値-100に設定
		{
			stylers: [{
				saturation: -100
			}]
		}
	];


	//マップ作成
	map = new google.maps.Map(area, {
		center,
		zoom: 12,
		styles: styles
	});

	//マーカーオプション設定
	const markerOption = {
		position: center, // マーカーを立てる位置を指定
		map: map, // マーカーを立てる地図を指定
		icon: {
			url: '/img/common/map_pin.png', // お好みの画像までのパスを指定
			scaledSize: new google.maps.Size(59, 79) // サイズ変更
		}
	}
	//マーカー作成
	const marker = new google.maps.Marker(markerOption);
}
